import { literal, struct } from 'io-ts/Decoder';

import { Type as Frame } from '../frame/Type';

/**
 * Sent when a new frame is created.
 */
export const FrameUpdated = struct({
	type: literal('frame-updated'),
	frame: Frame,
});
